/* Rodin Products — PDP configurator
   Vanilla JS, no dependencies. Operates on the markup rendered by
   sections/rodin-product.liquid. All prices are surcharges in EUR.
   Live price mirrors the Shopify cart/checkout price by adding hidden
   surcharge variants alongside the main steering-wheel variant. The visual
   design stays untouched; this script only handles state, price and cart. */
(function () {
  function init(root) {
    if (!root || root.dataset.rdInit) return;
    root.dataset.rdInit = '1';

    var base = parseFloat(root.dataset.basePrice || '0');          // product price, active presentment currency
    var shopifyCurrency = (window.Shopify && window.Shopify.currency) || {};
    var currencyCode = root.dataset.currencyCode || shopifyCurrency.active || 'EUR';
    var countryCode = root.dataset.countryCode || '';
    var currencyRate = parseFloat(shopifyCurrency.rate || '1');
    if (!isFinite(currencyRate) || currencyRate <= 0) currencyRate = 1;
    var productTitle = root.dataset.productTitle || document.title || 'Rodin Produkt';

    // surcharge tables are stored in shop currency (EUR). Displayed values are
    // converted with Shopify.currency.rate; real cart/checkout prices still come
    // from the corresponding Shopify surcharge variants.
    var P = {
      material: { leather: 0, alcantara: 119, carbon: 169, forged: 348, wood: 199 },
      grip:     { perfLeather: 0, smoothLeather: 10, alcantara: 79 },
      paddles:  { none: 0, standard: 0, carbon: 99, lamborghini: 99 },
      airbag:   { standard: 0, leather: 49, alcantara: 79 },
      opt:      { heating: 199, vibration: 149, acc: 59, led: 269, handsfree: 99, startstop: 125, driveselect: 125 },
      stitchCustom: 10, markerCustom: 10
    };

    // Real Shopify surcharge variant IDs (Konfigurations-Aufpreis Lenkrad).
    // They are non-shipping, non-tracked variants so checkout totals match the configurator.
    var ADDON = {
      materialByDelta: {
        50: '58045407691087', 80: '58045407822159',
        119: '58045406970191', 149: '58045406904655', 169: '58045407297871',
        179: '58045408084303', 199: '58045407723855', 229: '58045409853775',
        338: '58045409919311', 348: '58045407985999'
      },
      gripSmooth: '58045310402895',
      gripAlcantara: '58045309944143',
      gripAlcantaraDiff69: '58045310042447',
      stitchCustom: '58045416112463',
      markerCustom: '58045245489487',
      paddlesCarbon: '58045477552463',
      paddlesLamborghini55: '58236502376783',
      airbagLeather: '58045246669135',
      airbagAlcantara: '58045246275919',
      airbagAlcantaraDiff30: '58045246570831',
      heating199: '58045406839119',
      heating149: '58045406904655',
      vibration149: '58045496492367',
      vibration99: '58045496525135',
      vibration59: '58045496557903',
      acc59: '58045246079311',
      acc49: '58045246144847',
      led269: '58045313745231',
      handsfree99: '58045310468431',
      startStop125: '58236453388623',
      driveSelect125: '58236453552463'
    };

    var baseMaterial = root.dataset.baseMaterial || 'carbon';
    var baseConfig = {};
    try { baseConfig = root.dataset.baseConfig ? JSON.parse(root.dataset.baseConfig) : {}; } catch (e) { baseConfig = {}; }
    var aliases = {
      material: { leder:'leather', leather:'leather', alcantara:'alcantara', carbon:'carbon', forged:'forged', forged_carbon:'forged', forgedcarbon:'forged', echtholz:'wood', wood:'wood', holz:'wood' },
      grip: { perforiertes_leder:'perfLeather', perf_leder:'perfLeather', perfLeather:'perfLeather', smooth_leather:'smoothLeather', glattes_leder:'smoothLeather', smoothLeather:'smoothLeather', alcantara:'alcantara' },
      color: { bmw_m:'mtri', m:'mtri', mtri:'mtri', tricolor:'mtri', schwarz:'black', black:'black', blau:'blue', blue:'blue', rot:'red', red:'red', weiss:'white', white:'white', silber:'silver', silver:'silver', gelb:'yellow', yellow:'yellow', standard:'mtri', keine:'none', none:'none' },
      paddles: { keine:'none', none:'none', standard:'standard', carbon:'carbon', lamborghini:'lamborghini' },
      airbag: { standard:'standard', leder:'leather', leather:'leather', alcantara:'alcantara' }
    };
    function canon(group, value, fallback) {
      if (value === undefined || value === null || value === '') return fallback;
      var raw = String(value).trim();
      var key = raw.replace(/-/g, '_').replace(/\s+/g, '_').toLowerCase();
      return (aliases[group] && (aliases[group][raw] || aliases[group][key])) || fallback;
    }
    baseMaterial = canon('material', baseConfig.material, baseMaterial);
    var state = {
      baseMaterial: baseMaterial,
      material: canon('material', baseConfig.material, baseMaterial),
      carbonFinish: baseConfig.carbonFinish || baseConfig.carbon_finish || 'glossy',
      forgedColor: canon('color', baseConfig.forgedColor || baseConfig.forged_color, 'silver'),
      forgedColorCode: baseConfig.forgedColorCode || baseConfig.forged_color_code || '',
      baseGrip: canon('grip', baseConfig.grip, 'perfLeather'),
      grip: canon('grip', baseConfig.grip, 'perfLeather'),
      basePaddles: canon('paddles', baseConfig.paddles, 'standard'),
      paddles: canon('paddles', baseConfig.paddles, 'standard'),
      baseAirbag: canon('airbag', baseConfig.airbag, 'standard'),
      airbag: canon('airbag', baseConfig.airbag, 'standard'),
      baseStitch: canon('color', baseConfig.stitch, 'mtri'),
      stitch: canon('color', baseConfig.stitch, 'mtri'), stitchColor: baseConfig.stitchColor || baseConfig.stitch_color || '',
      baseMarker: canon('color', baseConfig.marker, 'mtri'),
      marker: canon('color', baseConfig.marker, 'mtri'), markerColor: baseConfig.markerColor || baseConfig.marker_color || '',
      heating: !!baseConfig.heating, vibration: !!baseConfig.vibration, acc: !!baseConfig.acc, led: !!baseConfig.led, handsfree: !!baseConfig.handsfree,
      startstop: !!baseConfig.startstop, driveselect: !!baseConfig.driveselect
    };
    var baseOptions = { heating: !!baseConfig.heating, vibration: !!baseConfig.vibration, acc: !!baseConfig.acc, led: !!baseConfig.led, handsfree: !!baseConfig.handsfree, startstop: !!baseConfig.startstop, driveselect: !!baseConfig.driveselect };

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    function activateChoice(selector, value) {
      var grp = root.querySelector(selector);
      if (!grp) return;
      grp.querySelectorAll('[data-val]').forEach(function (b) {
        if (b.getAttribute('data-val') === value) b.setAttribute('data-active', '1');
        else b.removeAttribute('data-active');
      });
    }
    activateChoice('[data-seg="material"]', state.material);
    activateChoice('[data-seg="grip"]', state.grip);
    activateChoice('[data-seg="paddles"]', state.paddles);
    activateChoice('[data-seg="airbag"]', state.airbag);
    activateChoice('[data-seg="carbonFinish"]', state.carbonFinish);
    activateChoice('[data-swatch="stitch"]', state.stitch);
    activateChoice('[data-swatch="marker"]', state.marker);
    activateChoice('[data-swatch="forgedColor"]', state.forgedColor);
    ['heating','vibration','acc','led','handsfree','startstop','driveselect'].forEach(function (k) {
      var t = root.querySelector('[data-toggle="' + k + '"]');
      if (t) {
        t.setAttribute('aria-pressed', state[k] ? 'true' : 'false');
        if ((k === 'startstop' || k === 'driveselect') && baseOptions[k]) {
          t.setAttribute('data-included', 'true');
          t.setAttribute('aria-disabled', 'true');
        }
      }
    });
    function presentmentFromEur(n) { return Number(n || 0) * currencyRate; }
    function formattedAmount(n, minimumFractionDigits) {
      var amount = Number(n || 0);
      var digits = typeof minimumFractionDigits === 'number' ? minimumFractionDigits : 2;
      var locale = countryCode === 'CH' ? 'de-CH' : 'de-DE';
      var number = amount.toLocaleString(locale, {
        minimumFractionDigits: digits,
        maximumFractionDigits: 2
      });
      if (currencyCode === 'EUR') return '€' + number;
      if (currencyCode === 'CHF') return 'CHF ' + number;
      return currencyCode + ' ' + number;
    }
    function fmt(n) { return formattedAmount(n, 2); }
    function fmtEurDelta(n) {
      var converted = presentmentFromEur(n);
      var digits = Math.abs(converted - Math.round(converted)) < 0.005 ? 0 : 2;
      return formattedAmount(converted, digits);
    }
    function deltaLabel(n) { return ' +' + fmtEurDelta(n); }
    function localizeStaticSurcharges() {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (node) {
        if (!/\+€\s*\d/.test(node.nodeValue || '')) return;
        node.nodeValue = node.nodeValue.replace(/\+€\s*(\d+(?:[.,]\d+)?)/g, function (_, raw) {
          return '+' + fmtEurDelta(parseFloat(raw.replace(',', '.')));
        });
      });
    }
    localizeStaticSurcharges();
    function gripDelta(value) {
      return Math.max(0, (P.grip[value] || 0) - (P.grip[state.baseGrip] || 0));
    }
    function updateGripPriceLabels() {
      var labels = { perfLeather:'Perf. Leder', smoothLeather:'Glattes Leder', alcantara:'Alcantara' };
      var grp = root.querySelector('[data-seg="grip"]');
      if (!grp) return;
      grp.querySelectorAll('[data-val]').forEach(function (btn) {
        var value = btn.getAttribute('data-val');
        var label = labels[value] || btn.getAttribute('data-label') || value;
        var delta = gripDelta(value);
        btn.textContent = label + (delta > 0 ? deltaLabel(delta) : '');
      });
    }
    function optionDelta(table, baseValue, value) {
      return Math.max(0, (table[value] || 0) - (table[baseValue] || 0));
    }
    function paddlesDelta(value) {
      if (value === 'lamborghini' && state.basePaddles !== 'lamborghini') return P.paddles.lamborghini;
      return optionDelta(P.paddles, state.basePaddles, value);
    }
    function updatePaddlesPriceLabels() {
      var labels = { none:'Keine', standard:'Standard', carbon:'Carbon', lamborghini:'Lamborghini' };
      var grp = root.querySelector('[data-seg="paddles"]');
      if (!grp) return;
      grp.querySelectorAll('[data-val]').forEach(function (btn) {
        var value = btn.getAttribute('data-val');
        var label = labels[value] || btn.getAttribute('data-label') || value;
        var delta = paddlesDelta(value);
        btn.textContent = label + (delta > 0 ? deltaLabel(delta) : '');
      });
    }
    function updateAirbagPriceLabels() {
      var labels = { standard:'Standard', leather:'Leder', alcantara:'Alcantara' };
      var grp = root.querySelector('[data-seg="airbag"]');
      if (!grp) return;
      grp.querySelectorAll('[data-val]').forEach(function (btn) {
        var value = btn.getAttribute('data-val');
        var label = labels[value] || btn.getAttribute('data-label') || value;
        var delta = optionDelta(P.airbag, state.baseAirbag, value);
        btn.textContent = label + (delta > 0 ? deltaLabel(delta) : '');
      });
    }
    function normHex(v) {
      if (!v) return null;
      var h = String(v).trim(); if (h[0] !== '#') h = '#' + h;
      return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(h) ? h : null;
    }
    function prop(name, value) {
      var el = root.querySelector('[data-prop="' + name + '"]');
      if (el) el.value = value;
    }
    function addonVariantForToggle(k, price) {
      if (k === 'heating') return price === 149 ? ADDON.heating149 : ADDON.heating199;
      if (k === 'vibration') return price === 59 ? ADDON.vibration59 : (price === 99 ? ADDON.vibration99 : ADDON.vibration149);
      if (k === 'acc') return price === 49 ? ADDON.acc49 : ADDON.acc59;
      if (k === 'led') return ADDON.led269;
      if (k === 'handsfree') return ADDON.handsfree99;
      if (k === 'startstop') return ADDON.startStop125;
      if (k === 'driveselect') return ADDON.driveSelect125;
      return null;
    }
    function selectedAddons() {
      var addons = [];
      var Lm = { leather:'Leder', alcantara:'Alcantara', carbon:'Carbon', forged:'Forged Carbon', wood:'Echtholz' };
      function add(id, label, price) { if (id && price > 0) addons.push({ id: String(id), label: label, price: Number(price) }); }
      var matDelta = Math.max(0, (P.material[state.material] || 0) - (P.material[state.baseMaterial] || 0));
      add(ADDON.materialByDelta[matDelta], 'Material-Upgrade: ' + (Lm[state.baseMaterial] || state.baseMaterial) + ' → ' + (Lm[state.material] || state.material), matDelta);
      var gripDelta = Math.max(0, (P.grip[state.grip] || 0) - (P.grip[state.baseGrip] || 0));
      if (gripDelta === 10) add(ADDON.gripSmooth, 'Griffbereiche: Glattes Leder', 10);
      if (gripDelta === 79) add(ADDON.gripAlcantara, 'Griffbereiche: Alcantara', 79);
      if (gripDelta === 69) add(ADDON.gripAlcantaraDiff69, 'Griffbereiche: Alcantara', 69);
      if (state.stitch !== state.baseStitch && state.stitch !== 'none') add(ADDON.stitchCustom, 'Nahtfarbe: Sonderfarbe', 10);
      if (state.marker !== state.baseMarker && state.marker !== 'none') add(ADDON.markerCustom, '12-Uhr-Markierung: Sonderfarbe', 10);
      var paddleCharge = paddlesDelta(state.paddles);
      if (state.paddles === 'carbon' && paddleCharge === 99) add(ADDON.paddlesCarbon, 'Schaltwippen: Carbon', 99);
      if (state.paddles === 'lamborghini' && paddleCharge === 99) add(ADDON.paddlesLamborghini55, 'Schaltwippen: Lamborghini', 99);
      var airbagDelta = Math.max(0, (P.airbag[state.airbag] || 0) - (P.airbag[state.baseAirbag] || 0));
      if (airbagDelta === 49) add(ADDON.airbagLeather, 'Airbag-Cover: Leder', 49);
      if (airbagDelta === 79) add(ADDON.airbagAlcantara, 'Airbag-Cover: Alcantara', 79);
      if (airbagDelta === 30) add(ADDON.airbagAlcantaraDiff30, 'Airbag-Cover: Alcantara', 30);
      ['heating', 'vibration', 'acc', 'led', 'handsfree', 'startstop', 'driveselect'].forEach(function (k) {
        if (!state[k] || baseOptions[k]) return;
        var b = root.querySelector('[data-toggle="' + k + '"]');
        var price = b ? parseFloat(b.getAttribute('data-price')) : NaN;
        price = isNaN(price) ? (P.opt[k] || 0) : price;
        var label = ({heating:'Lenkradheizung', vibration:'Vibration / Spurhalte / Distronic', acc:'ACC / Abstandsregelung', led:'LED-Schaltanzeige', handsfree:'Hands-free', startstop:'Start/Stop Button', driveselect:'Drive Select Button'})[k] || k;
        add(addonVariantForToggle(k, price), label, price);
      });
      return addons;
    }

    function total() {
      var presentmentBase = parseFloat(root.dataset.basePrice || '0');
      var surchargeEur = 0;
      surchargeEur += Math.max(0, (P.material[state.material] || 0) - (P.material[state.baseMaterial] || 0));
      surchargeEur += Math.max(0, (P.grip[state.grip] || 0) - (P.grip[state.baseGrip] || 0));
      surchargeEur += paddlesDelta(state.paddles);
      surchargeEur += Math.max(0, (P.airbag[state.airbag] || 0) - (P.airbag[state.baseAirbag] || 0));
      if (state.stitch !== state.baseStitch && state.stitch !== 'none') surchargeEur += P.stitchCustom;
      if (state.marker !== state.baseMarker && state.marker !== 'none') surchargeEur += P.markerCustom;
      ['heating', 'vibration', 'acc', 'led', 'handsfree', 'startstop', 'driveselect'].forEach(function (k) {
        if (state[k] && !baseOptions[k]) {
          var b = root.querySelector('[data-toggle="' + k + '"]');
          var dp = b ? parseFloat(b.getAttribute('data-price')) : NaN;
          surchargeEur += isNaN(dp) ? (P.opt[k] || 0) : dp;
        }
      });
      return presentmentBase + presentmentFromEur(surchargeEur);
    }

    function render() {
      updateGripPriceLabels();
      updatePaddlesPriceLabels();
      updateAirbagPriceLabels();
      var t = total();
      $$('[data-total]').forEach(function (el) { el.textContent = fmt(t); });
      prop('Konfigurator-Endpreis', fmt(t));
      var m = $('[data-monthly]'); if (m) m.textContent = fmt(Math.round(t / 24));
      // mirror to line-item properties (Deutsch; leere Werte werden im Warenkorb ausgeblendet)
      var L = {
        material: { carbon:'Carbon', forged:'Forged Carbon', leather:'Leder', alcantara:'Alcantara', wood:'Echtholz' },
        grip: { perfLeather:'Perforiertes Leder', smoothLeather:'Glattes Leder', alcantara:'Alcantara' },
        color: { mtri:'BMW M (Tricolor)', blue:'Blau', red:'Rot', white:'Wei\u00df', black:'Schwarz', silver:'Silber', yellow:'Gelb', custom:'Eigene Farbe', none:'Keine' },
        paddles: { none:'Keine', standard:'Standard', carbon:'Carbon', lamborghini:'Lamborghini' },
        airbag: { standard:'Standard', leather:'Leder', alcantara:'Alcantara' }
      };
      function tr(map, v){ return map[v] || v; }
      var modelEl = $('[data-model]') || $('[data-variant]');
      prop('Modell', modelEl ? (modelEl.options && modelEl.selectedIndex >= 0 ? modelEl.options[modelEl.selectedIndex].text.replace(/\s+—\s+.*/, '') : modelEl.value) : '');
      prop('Kranz-Material', tr(L.material, state.material) + (state.material === 'carbon' ? ' (' + (state.carbonFinish === 'matte' ? 'Matt' : 'Glänzend') + ')' : '') + (state.material === 'forged' ? ' (' + (state.forgedColor === 'custom' ? (state.forgedColorCode || 'Eigene') : tr(L.color, state.forgedColor)) + ')' : ''));
      var carbonWrap = root.querySelector('[data-carbon-wrap]');
      if (carbonWrap) { if (state.material === 'carbon') carbonWrap.removeAttribute('hidden'); else carbonWrap.setAttribute('hidden',''); }
      var forgedWrap = root.querySelector('[data-forged-wrap]');
      if (forgedWrap) { if (state.material === 'forged') forgedWrap.removeAttribute('hidden'); else forgedWrap.setAttribute('hidden',''); }
      prop('Griffbereiche', tr(L.grip, state.grip));
      prop('Nahtfarbe', state.stitch === 'custom' ? (state.stitchColor || 'Eigene Farbe') : tr(L.color, state.stitch));
      prop('12-Uhr-Markierung', state.marker === 'custom' ? (state.markerColor || 'Eigene Farbe') : tr(L.color, state.marker));
      prop('Schaltwippen', tr(L.paddles, state.paddles));
      prop('Airbag-Cover', tr(L.airbag, state.airbag));
      prop('Lenkradheizung', state.heating ? 'Ja' : '');
      prop('Vibration', state.vibration ? 'Ja' : '');
      prop('ACC', state.acc ? 'Ja' : '');
      prop('LED-Schaltanzeige', state.led ? 'Ja' : '');
      var hfBtn = root.querySelector('[data-toggle="handsfree"]');
      prop('Hands-free', (hfBtn && state.handsfree) ? 'Ja' : '');
      var startStopBtn = root.querySelector('[data-toggle="startstop"]');
      prop('Start/Stop Button', (startStopBtn && state.startstop) ? 'Ja' : '');
      var driveSelectBtn = root.querySelector('[data-toggle="driveselect"]');
      prop('Drive Select Button', (driveSelectBtn && state.driveselect) ? 'Ja' : '');
    }

    root.__rdRender = render;

    // segmented chips: [data-seg="group"] with [data-val]
    $$('[data-seg]').forEach(function (grp) {
      var key = grp.getAttribute('data-seg');
      grp.querySelectorAll('[data-val]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state[key] = btn.getAttribute('data-val');
          grp.querySelectorAll('[data-val]').forEach(function (b) { b.removeAttribute('data-active'); });
          btn.setAttribute('data-active', '1');
          render();
        });
      });
    });

    // swatches: [data-swatch="stitch|marker"] with [data-val]
    $$('[data-swatch]').forEach(function (grp) {
      var key = grp.getAttribute('data-swatch');
      var act = grp.querySelector('[data-val][data-active]');
      if (act) state[key] = act.getAttribute('data-val');
      grp.querySelectorAll('[data-val]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          state[key] = sw.getAttribute('data-val');
          grp.querySelectorAll('[data-val]').forEach(function (b) { b.removeAttribute('data-active'); });
          sw.setAttribute('data-active', '1');
          var custom = grp.parentNode.querySelector('[data-custom="' + key + '"]');
          if (custom) custom.removeAttribute('data-active');
          render();
        });
      });
    });

    // custom color: pickers + hex inputs
    function wireCustom(key, colorKey) {
      var pick = root.querySelector('input[data-pick="' + key + '"]');
      var hex = root.querySelector('input[data-hex="' + key + '"]');
      var dot = root.querySelector('[data-custom="' + key + '"]');
      function activate(v) {
        state[key] = 'custom'; state[colorKey] = v;
        var grp = root.querySelector('[data-swatch="' + key + '"]');
        if (grp) grp.querySelectorAll('[data-val]').forEach(function (b) { b.removeAttribute('data-active'); });
        if (dot) { dot.setAttribute('data-active', '1'); dot.style.background = v; }
        render();
      }
      if (pick) pick.addEventListener('input', function (e) {
        if (hex) hex.value = e.target.value; activate(e.target.value);
      });
      if (hex) hex.addEventListener('input', function (e) {
        var v = normHex(e.target.value); if (v) activate(v);
      });
    }
    wireCustom('stitch', 'stitchColor');
    wireCustom('marker', 'markerColor');
    wireCustom('forgedColor', 'forgedColorCode');

    // toggles: [data-toggle="key"]
    $$('[data-toggle]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('data-included') === 'true') return;
        var k = t.getAttribute('data-toggle');
        state[k] = !state[k];
        t.setAttribute('aria-pressed', state[k] ? 'true' : 'false');
        render();
      });
    });

    // model dropdown -> required gate for submit message
    var model = $('[data-model]') || $('[data-variant]');
    if (model) model.addEventListener('change', render);

    // collapsible configurator
    var toggleBtn = $('[data-config-toggle]');
    var panel = $('[data-config-panel]');
    if (toggleBtn && panel) {
      toggleBtn.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden') ? false : true;
        if (open) { panel.setAttribute('hidden', ''); toggleBtn.setAttribute('aria-expanded', 'false'); }
        else { panel.removeAttribute('hidden'); toggleBtn.setAttribute('aria-expanded', 'true'); }
      });
    }

    // Safari-safe cart transport. Some WebKit sessions reject the relative fetch chain
    // with "The string did not match the expected pattern" before Shopify can respond.
    function cartPost(path, payload, stage) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        try {
          xhr.open('POST', window.location.origin + path, true);
          xhr.setRequestHeader('Accept', 'application/json');
          if (payload) xhr.setRequestHeader('Content-Type', 'application/json');
        } catch (err) {
          reject(new Error('Cart-Fehler bei ' + stage + ': ' + err.message));
          return;
        }
        xhr.onload = function () {
          var response = null;
          try { response = xhr.responseText ? JSON.parse(xhr.responseText) : null; } catch (_) { response = null; }
          if (xhr.status >= 200 && xhr.status < 300) { resolve(response); return; }
          var message = response && (response.description || response.message);
          reject(new Error('Cart-Fehler bei ' + stage + ': ' + (message || ('HTTP ' + xhr.status))));
        };
        xhr.onerror = function () { reject(new Error('Cart-Fehler bei ' + stage + ': Netzwerkfehler')); };
        xhr.onabort = function () { reject(new Error('Cart-Fehler bei ' + stage + ': Anfrage abgebrochen')); };
        try { xhr.send(payload ? JSON.stringify(payload) : null); }
        catch (err) { reject(new Error('Cart-Fehler bei ' + stage + ': ' + err.message)); }
      });
    }

    // submit via AJAX so main product + real surcharge variants enter cart together
    var form = root.querySelector('form[action*="/cart/add"], form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitter = e.submitter || document.activeElement;
        var variantSelect = form.querySelector('select[name="id"]');
        var variantInput = variantSelect || form.querySelector('input[name="id"]');
        if (variantSelect && !variantSelect.value) { variantSelect.reportValidity(); return; }
        if (!variantInput || !variantInput.value) { return; }
        render();
        var props = {};
        $$('input[data-prop], textarea[data-prop], select[data-prop]').forEach(function (i) {
          var value = (i.value || '').trim ? (i.value || '').trim() : i.value;
          if (value) props[i.name.replace(/^properties\[/,'').replace(/\]$/,'')] = value;
        });
        var configId = 'rd-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        props._rodin_config_id = configId;
        var items = [{ id: String(variantInput.value), quantity: 1, properties: props }];
        selectedAddons().forEach(function (a) {
          // Only hidden properties on surcharge lines: Shopify checkout can expose
          // visible properties, so the customer-facing label comes from the
          // variant title while grouping/removal uses hidden underscored props.
          items.push({
            id: a.id, quantity: 1,
            properties: { '_rodin_config_addon': 'true', '_rodin_config_id': configId, '_rodin_addon_label': a.label }
          });
        });
        var returnTo = (form.querySelector('[name="return_to"]') || {}).value || '';
        var oldText = submitter && submitter.textContent;
        if (submitter) { submitter.disabled = true; submitter.textContent = 'Wird hinzugefügt …'; }
        // A Rodin configuration is one priced bundle. Clear the previous cart first
        // so old/stale surcharge lines cannot survive into checkout.
        cartPost('/cart/clear.js', null, 'Warenkorb leeren')
        .then(function () {
          return cartPost('/cart/add.js', { items: items }, 'Hinzufügen');
        }).then(function () {
          var destination = (returnTo === '/checkout' || returnTo === '/checkout?locale=de') ? '/checkout?locale=de' : '/cart';
          window.location.assign(window.location.origin + destination);
        }).catch(function (err) {
          alert('Konnte nicht in den Warenkorb gelegt werden: ' + err.message);
          if (submitter) { submitter.disabled = false; submitter.textContent = oldText; }
        });
      });
    }

    // floating sticky CTA: show after scroll, hide near footer
    var sticky = $('[data-sticky]');
    if (sticky) {
      var onScroll = function () {
        var footer = document.querySelector('[data-rd-footer], footer');
        var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight + 40 : false;
        var show = window.scrollY > 520 && !nearFooter;
        sticky.style.display = show ? 'flex' : 'none';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Mercedes-only label guard: Shopify can briefly serve a cached generic
    // explanation section after a theme update. Keep those labels consistent
    // with the Mercedes configurator without changing keys, prices or other brands.
    function normalizeMercedesOptionCopy() {
      if (!/mercedes(?:-benz)?/i.test(productTitle)) return;
      document.querySelectorAll('.rds-card').forEach(function (card) {
        var parts = card.querySelectorAll(':scope > div');
        var heading = parts[0];
        var copy = parts[1];
        if (!heading) return;
        var text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
        if (text.indexOf('📡') === 0 && /(ACC|Abstandsregelung|Distronic)/i.test(text)) {
          heading.textContent = '📡 Distronic';
          if (copy) copy.textContent = (copy.textContent || '').replace(/ACC-Funktion/g, 'Distronic-Funktion');
        }
        if (text.indexOf('〰') === 0 && /(Vibration|Spurhalte|Distronic)/i.test(text)) {
          heading.textContent = '〰 Vibration';
        }
      });
    }
    normalizeMercedesOptionCopy();

    render();
  }

  function boot() {
    document.querySelectorAll('[data-rodin-configurator]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-rodin-configurator]').forEach(init);
  });
})();

